module.exports = __webpack_public_path__ + "img/groundFloor.4e14e0c8.png";